import { DocumentBirthFilterForm } from 'civil-status/view-models/document-birth-list';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesDocumentBirthSearch: DocumentBirthFilterForm = {
  page: 0,
  rowsPerPage: 10,
  orders: {},
  year: '',
  document: '',
  registry: null,
  portion: '',
  serie: '',
  matricola: '',
  surname: '',
  name: '',
  operationYear: '0',
  operationDocument: '0',
  operationRegistry: '0',
  operationPortion: '0',
  operationSerie: '0',
  operationMatricola: '0',
  operationSurname: '0',
  operationName: '0',
};

const PageDocumentBirthSearchInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesDocumentBirthSearch}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageDocumentBirthSearchInitializer.displayName = 'Page search birth initializer component';

export default PageDocumentBirthSearchInitializer;
